import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=3532d7a0&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"
import style0 from "./Board.vue?vue&type=style&index=0&id=3532d7a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3532d7a0",
  null
  
)

export default component.exports